var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1035 3.86299C10.4606 3.34059 9.53942 3.34059 8.89646 3.86299L3.39646 8.33174C2.98747 8.66405 2.75 9.16297 2.75 9.68994V15.5C2.75 16.4665 3.5335 17.25 4.5 17.25H6.75V12.5C6.75 10.7051 8.20507 9.25002 10 9.25002C11.7949 9.25002 13.25 10.7051 13.25 12.5V17.25H15.5C16.4665 17.25 17.25 16.4665 17.25 15.5V9.68994C17.25 9.16297 17.0125 8.66405 16.6035 8.33174L11.1035 3.86299ZM11.75 17.25V12.5C11.75 11.5335 10.9665 10.75 10 10.75C9.0335 10.75 8.25 11.5335 8.25 12.5V17.25H11.75ZM7.95057 2.69882C9.14463 1.72865 10.8554 1.72865 12.0494 2.69882L17.5494 7.16757C18.309 7.78471 18.75 8.71127 18.75 9.68994V15.5C18.75 17.2949 17.2949 18.75 15.5 18.75H4.5C2.70507 18.75 1.25 17.2949 1.25 15.5V9.68994C1.25 8.71127 1.69102 7.78471 2.45057 7.16757L7.95057 2.69882Z",
    fill: "#D9DBE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-Home.87d0ac5d9e887198274ccf8b48eefdda.svg";
export { ForwardRef as ReactComponent };